export const SsoModalActionType = {
    OPEN_SSO_MODAL: 'OPEN_SSO_MODAL',
    SET_SSO_ACCOUNT_LIST: 'SET_SSO_ACCOUNT_LIST',
    SET_SELECTED_SI_NUMBER: 'SET_SELECTED_SI_NUMBER',
    SET_SELECTED_LOB: 'SET_SELECTED_LOB'
}